// Use this controller for modals rendered from AJAX calls
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal'];

  connect() {
    window.modalManager = this;
  }

  setModal (e) {
    // [xhr, options]
    const [xhr] = e.detail
    xhr.setRequestHeader('X-Modal', 'true')
  }

  open(event) {
    const [data] = event.detail

    let modal = data.body.querySelector('.modal')
    let node = document.importNode(modal, true)
    if (event.target.dataset.modalId) {
      node.id = event.target.dataset.modalId
    }

    this.turbo_frame_tag = event.target.dataset.id || null
    let turbo_frame_tag = this.turbo_frame_tag

    if (turbo_frame_tag) {
      let turboFrame = document.createElement('turbo-frame')
      turboFrame.id = turbo_frame_tag
      turboFrame.appendChild(node)
      document.body.querySelector('main').appendChild(turboFrame)
    } else {
      document.body.querySelector('main').appendChild(node)
    }
  }

  close(event) {
    this.modalTarget.remove()
  }

  closeAll() {
    this.modalTargets.forEach((modal) => modal.remove());
  }

  closeIfBackdrop(event) {
    if (event.target.dataset.modalBackdrop !== undefined) {
      const modalId = event.target.id;
      const modal = this.modalTargets.find((el) => el.id === modalId);
      if (modal) {
        modal.remove();
      }
    }
  }
}
